<template>
  <div
    v-show="mapIsLoading"
    class="map-loading-div mt-1"
  >
    <v-row>
      <div class="caption pr-2">Laster kartdata</div>
      <v-progress-circular
        style=""
        size="16"
        indeterminate
        color="primary"
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import { loadModules } from "esri-loader";
export default {
  name: "map-loading-bar",
  props: {
    mapViewObject: Object
  },
  data: () => {
    return {
      mapIsLoading: true
    }
  },
  mounted: function () {
    loadModules(
      [
        "esri/core/watchUtils"
      ]
    )
      .then(
        ([
          watchUtils
        ]) => {

          watchUtils.whenTrue(this.mapViewObject, "updating", () => {
            this.mapIsLoading = true;
          });

          watchUtils.whenFalse(this.mapViewObject, "updating", () => {
            this.mapIsLoading = false;
          });
        })
  }
}
</script>

<style>
.map-loading-div {
  position: absolute;
  margin-left: 0px;
  right: 20px;
}
</style>